import styled from "@emotion/styled";

const StyledProgramInnerciseListControl = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid var(--cms-border);
  border-radius: 12px;
  background: var(--cms-surface-muted);
  padding: 12px;

  .header-bar {
    display: flex;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 0 10px;
    gap: 10px;
    flex-wrap: wrap;
    h4 {
      font-size: 14px;
      color: var(--cms-text-primary);
      margin: 0;
      font-weight: 800;
    }

    button {
      text-transform: none;
      font-weight: 700;
      border-radius: 9px;
    }
  }
  .resource-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
  }
  .resource-name {
    font-size: 14px;
    font-weight: 500;
    width: 80%;
    position: absolute;
    top: 55px;
    color: var(--cms-text-secondary);
  }

  .resource-empty {
    width: 100%;
    border: 1px dashed var(--cms-border);
    border-radius: 10px;
    padding: 16px;
    text-align: center;
    color: var(--cms-text-secondary);
    font-weight: 600;
    background: var(--cms-surface-secondary);
  }
`;

const StyledProgramInnerciseResourceWarper = styled.div`
  display: flex;
  flex-direction: column;

  .MuiFormControl-root {
    margin: 8px 4px 12px;
    width: 353px;
  }
`;

const StyledProgramInnerciseResourcePreview = styled.div`
  position: relative;
  display: flex;
  border: 2px dashed var(--cms-border);
  height: 200px;
  width: 330px;
  padding: 10px;
  border-radius: 5px;
  margin: 7px 15px;
  .action-btn {
    position: absolute;
    top: -12px;
    right: -12px;
    width: 10px;
    height: 10px;
    background-color: #1d4ed8;
    color: white;
  }
  video {
    width: 100%;
  }
  justify-content: space-around;
  align-items: center;
`;

export {
  StyledProgramInnerciseListControl,
  StyledProgramInnerciseResourceWarper,
  StyledProgramInnerciseResourcePreview,
};
